// Import and use some of the 'solid', 'regular', 'light' and 'brand' themes of FontAwesome 5 Free/PRO (.npmrc is required)
// We only add icons to the library that we actually use in frontend to keep the bundle size as small as possible
import { library, dom } from '@fortawesome/fontawesome-svg-core'

// Solid icons
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faTriangle } from '@fortawesome/pro-solid-svg-icons/faTriangle'
import { faSquare } from '@fortawesome/pro-solid-svg-icons/faSquare'
import { faFont } from '@fortawesome/pro-solid-svg-icons/faFont'

import { faCog } from '@fortawesome/pro-solid-svg-icons/faCog'
import { faFile } from '@fortawesome/pro-solid-svg-icons/faFile'
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf'

import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft'
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight'
import { faAngleUp } from '@fortawesome/pro-solid-svg-icons/faAngleUp'
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown'

import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { faPhone } from '@fortawesome/pro-solid-svg-icons/faPhone'
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload'
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch'
import { faLanguage } from '@fortawesome/pro-solid-svg-icons/faLanguage'
import { faRulerTriangle } from '@fortawesome/pro-solid-svg-icons/faRulerTriangle'
import { faShoppingCart } from '@fortawesome/pro-solid-svg-icons/faShoppingCart'
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faFilter } from '@fortawesome/pro-solid-svg-icons/faFilter'
import { faTag } from '@fortawesome/pro-solid-svg-icons/faTag'
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope'
import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft'
import { faArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp'
import { faArrowDown } from '@fortawesome/pro-solid-svg-icons/faArrowDown'
import { faBook } from '@fortawesome/pro-solid-svg-icons/faBook'
import { faSlidersH } from '@fortawesome/pro-solid-svg-icons/faSlidersH'
import { faBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding'
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt'
import { faLeaf } from '@fortawesome/pro-solid-svg-icons/faLeaf'
import { faCrosshairs } from '@fortawesome/pro-solid-svg-icons/faCrosshairs'
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark'
import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars'

// Regular icons
import { faClipboardListCheck } from '@fortawesome/pro-regular-svg-icons/faClipboardListCheck'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'

// Brand icons
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube'
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare'
import { faGooglePlus } from '@fortawesome/free-brands-svg-icons/faGooglePlus'

// Add imported icons to the library
library.add(
    faExclamationTriangle, faCheck, faTriangle, faSquare, faFont, faCog, faFile, faFilePdf,
    faAngleLeft, faAngleRight, faAngleUp, faAngleDown, faQuestionCircle, faInfoCircle, faPhone,
    faDownload, faSearch, faLanguage, faRulerTriangle, faShoppingCart, faPlusCircle, faPlus, faFilter,
    faTag, faEnvelope, faCircleNotch, faArrowRight, faArrowLeft, faArrowUp, faArrowDown, faBook, faSlidersH, faBuilding,
    faMapMarkerAlt, faLeaf, faCrosshairs, faXmark, faBars,

    faClipboardListCheck, faTrash,

    faYoutube, faFacebookSquare, faGooglePlus
)

// Kicks off the process of finding <i> tags and replacing with <svg>
dom.watch()
